var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ViewHighscore"},[_c('CenterColumn',[_c('h1',[_vm._v(" Top list ")]),_c('Highscore')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }